import { render, staticRenderFns } from "./FieldList.vue?vue&type=template&id=c96eb522"
import script from "./FieldList.vue?vue&type=script&lang=ts"
export * from "./FieldList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports